"use client";

import { useEffect, useState } from "react";

import { getDashboardSidebarCollapseMediaQuery } from "@/lib/layout/dashboard-sidebar";

export function useDashboardSidebarCollapsedState() {
  const query = getDashboardSidebarCollapseMediaQuery();

  const [isCollapsed, setIsCollapsed] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const media = window.matchMedia(query);

    const handleChange = (event: MediaQueryListEvent) => {
      setIsCollapsed(event.matches);
    };

    setIsCollapsed(media.matches);
    media.addEventListener("change", handleChange);
    return () => media.removeEventListener("change", handleChange);
  }, [query]);

  const toggleCollapse = () => setIsCollapsed((prev) => !prev);

  return { isCollapsed, toggleCollapse };
}
